import classNames from "classnames";
import { ReactComponent as IconCheck } from "kustom-front/src/icons/check.svg";
import noop from "lodash/noop";
import React, { FunctionComponent, useCallback } from "react";
import "./style.scss";

export type CheckBoxType = "round" | "square";

export interface Props {
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
  type: CheckBoxType;
}

const Checkbox: FunctionComponent<Props> = ({ checked, disabled = false, onChange, type }) => {
  const handleClick = useCallback(() => onChange(), [onChange]);

  return (
    <div
      className={classNames("Checkbox", {
        "Checkbox--checked": checked,
        "Checkbox--disabled": disabled,

        "Checkbox--type-round": type === "round",
        "Checkbox--type-square": type === "square",
      })}
      onClick={disabled ? noop : handleClick}
    >
      <IconCheck className="Checkbox-icon" />
    </div>
  );
};

export default Checkbox;
